( function() {

    document.addEventListener("DOMContentLoaded", function () {

        document.addEventListener('keydown', event => {
            const tabKey = event.key === 'Tab';

            //if tab key is pressed
            if (tabKey) {
                document.body.classList.add('show-focus-outlines');
            }
        });

        document.addEventListener('click', () => {
            // remove the class when click is pressed
            document.body.classList.remove('show-focus-outlines');
        });

    });

}() );